import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Training from "./pages/Training";
import Consulting from "./pages/Consulting";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";
import OpExEngage from "./pages/OpExEngage";
import OpExEngage_book from "./pages/OpExEngage_book";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/training" element={<Training />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/engage" element={<OpExEngage />} />
            <Route path="/engage_book" element={<OpExEngage_book />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />

          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
